var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCdkSmallLogoInActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 145,
    viewBox: "0 0 144 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_1167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.94 64.3999H65.67V79.9099H70.94C73.83 79.9099 75.3 79.2599 76.56 78.0499C78.03 76.6199 78.85 74.8499 78.85 72.2199C78.85 69.7599 78.12 67.9399 76.78 66.5199C75.53 65.1799 74.06 64.3999 70.95 64.3999H70.94Z",
    fill: "#9297a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 0.23999C32.34 0.23999 0.0799866 32.5 0.0799866 72.16C0.0799866 111.82 32.34 144.08 72 144.08C111.66 144.08 143.92 111.82 143.92 72.16C143.92 32.5 111.66 0.23999 72 0.23999ZM38.5 87.12C29.04 87.12 22.77 80.38 22.77 72.13C22.77 63.88 29.08 57.18 38.28 57.18C43.46 57.18 48.73 59.17 52.36 62.02L47.82 66.94C45.18 64.78 41.77 63.53 39.22 63.53C33.99 63.53 30.62 67.46 30.62 72.17C30.62 76.88 34.08 80.81 39.43 80.81C42.71 80.81 46.13 78.87 48.63 76.53L53.21 81.37C49.8 84.39 44.7 87.12 38.48 87.12H38.5ZM82.7 82.24C80.24 84.66 76.7 86.26 71.12 86.26H58.12V58.05H71.12C76.39 58.05 80.28 59.52 82.91 62.28C85.33 64.83 86.67 68.28 86.67 72.13C86.67 75.98 85.29 79.69 82.7 82.24ZM113.45 86.26L103.82 74.12L100.41 77.36V86.26H92.81V58.05H100.41V68.63L111.51 58.05H121.1L109.13 69.24L122.82 86.26H113.45Z",
    fill: "#9297a2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_1167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 145,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdkSmallLogoInActive);
export default __webpack_public_path__ + "static/media/cdkSmallLogoInActive.b2f7818b9197dee4352ba3fda4e90585.svg";
export { ForwardRef as ReactComponent };